import { render, staticRenderFns } from "./edit-header.vue?vue&type=template&id=1f264107"
import script from "./edit-header.vue?vue&type=script&lang=js"
export * from "./edit-header.vue?vue&type=script&lang=js"
import style0 from "./edit-header.vue?vue&type=style&index=0&id=1f264107&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports